/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ConfigService } from '../../core/services/config.service';
import { EditModeService } from '../../core/services/edit-mode.service';
import { LmsBaseAppComponent } from './../../core/component/base-app/lms-base-app.component';
import { LmsLoaderService } from '../../core/services/lms-loader.service';
import { LmsMenuService } from '../../core/services/lms-menu.service';
import { LmsModuleService } from '../../core/services/lms-module.service';
import { PopupService } from '../../core/services/popup.service';
import { QueryViewFiltersComponent } from './query-view-filters/query-view-filters.component';
import { QueryViewService } from '../shared/services/query-view.service';
import { RouteChangePopupService } from '../../core/services/route-change-popup.service';
import { TabService } from '../../core/services/tab.service';
import { UtilService } from '../../core/services/util.service';
import { StaticDataStoreService } from '../../core/services/static-datastore.service';
import { Subscription } from 'rxjs';
import { PermitAll } from '@csx/security';

/**
 * @export
 * @class QueryViewDataComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 * @implements {OnDestroy}
 */
@Component({
  selector: 'lms-query-view-data',
  templateUrl: './query-view-data.component.html',
  styleUrls: ['./query-view-data.component.scss']
})
@PermitAll()
export class QueryViewDataComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {
  lastRefreshTime: string;
  commonopsPicklist;
  configData: any;
  queryViewArr: [0];
  searchResult = false;
  searchType = '';
  tabStoreSubscription: any;
  queryViewSubscription: Subscription;
  filteredTabs = [];
  @ViewChild(QueryViewFiltersComponent) queryViewFiltersComponent: QueryViewFiltersComponent;

  constructor(
    configService: ConfigService,
    lmsMenuService: LmsMenuService,
    lmsModuleService: LmsModuleService,
    utilService: UtilService,
    editModeService: EditModeService,
    routeChangePopupService: RouteChangePopupService,
    popupService: PopupService,
    private queryViewService: QueryViewService,
    private lmsLoaderService: LmsLoaderService,
    private tabService: TabService,
    private staticDataStoreService: StaticDataStoreService
  ) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.type = 'Query-View';
    this.service = this.queryViewService;
    this.commonopsPicklist = this.staticDataStoreService.getValue('commonopsPicklist');
    this.queryViewSubscription = this.queryViewService.loadData.subscribe(data => {
      this.loadData = data;
      if (this.loadData && this.loadData.data) {
        this.searchResult = true;
        this.searchType = this.loadData['typeSearch'] === 'Trains' ? 'Trains' : 'Locomotives';
        for(let i=0;i<this.loadData.data.length;i++) {
          let item = this.loadData.data[i];
          item.oprtngZoneName = this.getOperatingZoneValue(item.oprtngZone);
          item.oprtngRegionName = this.getOperatingRegionValue(item.oprtngRegion);

        }
      } else {
        this.searchType = '';
      }
      this.lastRefreshTime = this.loadData ? this.loadData.refreshTime : '';

      this.editModeService.setEditResetMode(false);

    });
  }

  getOperatingRegionValue(value: string) {

    if (value !== undefined && value !== '') {
      let oprRegion = '-';
      if (this.commonopsPicklist && this.commonopsPicklist.oprRegionList) {
        oprRegion = this.commonopsPicklist.oprRegionList.find(obj => obj.oprRegionCode === value);
        if (oprRegion) {
          oprRegion = oprRegion['oprRegionName'];
        } else {
          oprRegion = '-';
        }
      }
      return oprRegion;
    } else {
      return '-';
    }
  }

  getOperatingZoneValue(value: string) {

    if (value !== undefined && value !== '') {
      let oprZone = '-';
      if (this.commonopsPicklist && this.commonopsPicklist.oprZoneList) {
        oprZone = this.commonopsPicklist.oprZoneList.find(obj => obj.oprZoneCode === value);
        if (oprZone) {
          oprZone = oprZone['oprZoneName'];
        } else {
          oprZone = '-';
        }
      }
      return oprZone;
    } else {
      return '-';
    }
  }

  /**
   * search method trigger load data
   * and reset edit mode
   * @memberof QueryViewDataComponent
   */
  search() {
    super.search();
    setTimeout(() => {
      this.editModeService.setEditMode({ message: '', status: false });
    }, 100);
  }

  /**
   * @memberof QueryViewDataComponent
   */
  ngOnInit() {
    super.init(this.search);
    this.tabStoreSubscription = this.tabService.tabStoreObservable.subscribe(data => {
      if (data) {
        const selectedTab = data.find((tab) => { return tab.selected; });
        if (selectedTab) {
          this.filteredTabs = data.filter((tab) => { return selectedTab.type === tab.type; });
        }
      }
    });
    this.init();
  }

  /**
   * @memberof QueryViewDataComponent
   */
  init() {
    this.selectedTab.queryView = this.selectedTab.queryView ? this.selectedTab.queryView : {};
  }


  /**
   * Invoked when click on refresh icon on header.
   * @memberOf LocoStatusComponent
   */
  refreshbtnEvent(event) {
    // this.lmsLoaderService.showLoader();
    this.queryViewFiltersComponent.searchFilterData(this.queryViewFiltersComponent.filtersForm);
  }

  /**
   * @param {any} $event
   * @memberof QueryViewDataComponent
   */
  getSearchType($event) {
    this.searchType = $event.typeName;
    this.searchResult = true;
    this.queryViewService.load(this.selectedTab, $event.requestObject, $event.typeName);
  }

  /**
  * Clear error message.
  * @param {any} event
  * @memberOf LocoStatusDataComponent
  */
  clearErrorMessage(event) {
    if (this.selectedTab && this.selectedTab.subTypeDetail && this.selectedTab.subTypeDetail.data && this.selectedTab.subTypeDetail.data.message) {
      this.selectedTab.subTypeDetail.data.message = '';
      this.updateTab(this.selectedTab);
    }
  }

  /**
   * @memberof QueryViewDataComponent
   */
  ngOnDestroy() {
    if (this.tabStoreSubscription) {
      this.tabStoreSubscription.unsubscribe();
    }
    if (this.queryViewSubscription) {
      this.queryViewSubscription.unsubscribe();
    }
    super.destroy();
    if (!this.editModeService.editMode) {
      this.queryViewService.resetTabData(this.selectedTab);
    }
  }
}

